import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { Box, Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import ATab from '../../common/ATab';
import { useState } from 'react';
import UserTable from '../../common/UserTable';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PaymentInfoModal from '../../finance/PaymentInfoModal.tsx';
import { Accounting } from '../../../enum/accounting.tsx';
import { Campaign } from '../../../enum/campaign.tsx';
import { Ticket } from '../../../enum/ticket.tsx';
import { Company } from '../../../enum/company.tsx';
import { MediaEntity } from '../../../enum/media_entity.tsx';

const ProfileGiver = () => {
	const { t } = useTranslation();
	let { id } = useParams();
	const [searchParams] = useSearchParams();
	let activeTab = searchParams.get('tab');

	const [activeItem, setActiveItem] = useState<string>(activeTab === 'campaign' ? t('campaigns') : t('manage_pages'));
	const headerClassNames = 'text-xs bg-background-paper';
	let navigate = useNavigate();
	const [open, setOpen] = useState(false);
	const [selectedPaymentId, setSelectedPaymentId] = useState<number | null>(null);
	const handleOpen = (id: number) => {
		setSelectedPaymentId(id);
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
		setSelectedPaymentId(null);
	};
	let tabItem = [
		{
			title: t('manage_pages'),
			api: '/admin/media-entities',
			icon: <AccountBalanceWalletIcon />,
			permission: MediaEntity.Index,
			view: true,
			viewAction: (id: number) => {
				navigate(`/my-social-media/edit/${id}?user_type=admin`);
			},
			columns: [
				{ field: 'title', flex: 1, headerName: t('group_and_channel_name'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				{ field: 'admin_name', flex: 1, headerName: t('admin_name'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				{
					field: 'media',
					flex: 1,
					headerName: t('social'),
					headerAlign: 'center',
					align: 'center',
					headerClassName: headerClassNames,
					renderCell: (params: any) => {
						t(`${params.row.media}`);
					},
				},
				{
					field: 'influencer_campaign',
					headerName: t('view_in_search'),
					flex: 2,
					headerClassName: `${headerClassNames}`,
					headerAlign: 'center',
					align: 'center',
					renderCell: (params: any) => (
						<FormGroup className="flex flex-row items-center justify-center pt-2">
							<FormControlLabel control={<Checkbox checked={params.row.view_campaign} />} label={t('view')} />
							<FormControlLabel control={<Checkbox checked={params.row.reserve_campaign} />} label={t('reserve')} />
							<FormControlLabel control={<Checkbox checked={params.row.influencer_campaign} />} label={t('influenceral')} />
						</FormGroup>
					),
				},
				{
					field: 'status',
					headerName: t('status'),
					width: 150,
					flex: 1,
					display: 'flex',
					headerClassName: `${headerClassNames}`,
					headerAlign: 'center',
					align: 'center',
					renderCell: (params: any) => {
						return <div className={`rounded-lg p-2.5 ${params.row.status === 'confirmed' ? 'bg-green-50 text-green-600' : params.row.status === 'rejected' ? 'bg-red-100 text-red-600' : 'bg-blue-100 text-blue-600'}`}>{params.row.status === 'confirmed' ? t('confirmed') : params.row.status === 'rejected' ? t('rejected') : t('confirmation_pend')}</div>;
					},
				},
			],
		},
		{
			title: t('manage_companys'),
			api: '/admin/companies',
			icon: <AccountBalanceWalletIcon />,
			permission: Company.Index,
			columns: [
				{ field: 'title', flex: 1, headerName: t('company_name'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				// { field: 'manager_name', flex: 1, headerName: t('manager_name'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				{
					field: 'created_at',
					flex: 1,
					headerName: t('created_time'),
					headerAlign: 'center',
					align: 'center',
					headerClassName: headerClassNames,
					renderCell: (params: any) => {
						return new Date(params.row.created_at).toLocaleDateString('fa-IR');
					},
				},
				{
					field: 'is_active',
					headerName: t('status'),
					width: 150,
					flex: 1,
					display: 'flex',
					headerClassName: `${headerClassNames}`,
					headerAlign: 'center',
					align: 'center',
					renderCell: (params: any) => {
						return <div className={`rounded-lg p-2.5 ${params.row.is_active === 1 ? 'bg-green-50 text-green-600' : 'bg-red-100 text-red-600'}`}>{params.row.is_active === 1 ? t('active') : t('inactive')}</div>;
					},
				},
			],
			route: 'admin/my-companies',
		},
		{
			title: t('finance'),
			api: '/admin/payments',
			icon: <AccountBalanceWalletIcon />,
			permission: Accounting.PaymentIndex,
			columns: [
				{
					field: 'id',
					headerName: t('row'),
					width: 90,
					headerAlign: 'center',
					align: 'center',
					headerClassName: headerClassNames,
				},
				{
					field: 'payment_id',
					headerName: t('payment_id'),
					flex: 1,
					headerAlign: 'left',
					align: 'left',
					headerClassName: headerClassNames,
				},
				{
					field: 'user',
					headerName: t('user'),
					flex: 1,
					headerAlign: 'left',
					align: 'left',
					headerClassName: headerClassNames,
				},
				{
					field: 'amount',
					headerName: t('amount'),
					flex: 1,
					headerAlign: 'left',
					align: 'left',
					headerClassName: headerClassNames,
				},
				{
					field: 'gateway',
					headerName: t('gateway'),
					flex: 1,
					headerAlign: 'left',
					align: 'left',
					headerClassName: headerClassNames,
				},
				{
					field: 'bank_ref_id',
					headerName: t('ref_id'),
					flex: 1,
					headerAlign: 'left',
					align: 'left',
					headerClassName: headerClassNames,
				},
				{
					field: 'created_at',
					headerName: t('date'),
					flex: 1,
					headerAlign: 'left',
					align: 'left',
					headerClassName: headerClassNames,
					renderCell: (params: any) => {
						return new Date(params?.value).toLocaleDateString('fa-IR');
					},
				},
				{
					field: 'payed',
					headerName: t('status'),
					flex: 1,
					headerAlign: 'left',
					headerClassName: `${headerClassNames} ps-12`,
					align: 'left',
					renderCell: (params: any) => {
						let statusText;
						let bgColorClass;
						if (params.row.status === 1) {
							statusText = t('payed');
							bgColorClass = 'bg-success-selected text-success-main';
						} else if (params.row.status === 0 || params.row.status === -1) {
							statusText = t('payment_error');
							bgColorClass = 'bg-error-selected text-error-main';
						} else {
							statusText = t('unknown_status');
							bgColorClass = 'bg-warning-selected text-warning-main';
						}

						return <div className={`ms-10 mt-4 flex w-[max-content] items-center rounded px-3 py-0.5 text-xs font-medium ${bgColorClass}`}>{statusText}</div>;
					},
				},
				{
					field: 'action',
					headerName: t('action'),
					minWidth: 160,
					headerAlign: 'center',
					headerClassName: headerClassNames,
					align: 'center',
					renderCell: (params: any) => {
						return (
							<>
								<IconButton onClick={() => handleOpen(params.row.id)}>
									<VisibilityIcon className="text-text-secondary" />
								</IconButton>
							</>
						);
					},
				},
			],
		},
		{
			title: t('tickets'),
			api: '/admin/tickets',
			icon: <AccountBalanceWalletIcon />,
			permission: Ticket.Index,
			columns: [
				{ field: 'title', flex: 1, headerName: t('group_and_channel_name'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				{ field: 'admin_name', flex: 1, headerName: t('admin_name'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				{ field: 'social', flex: 1, headerName: t('social'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				{
					field: 'status',
					headerName: t('status'),
					width: 150,
					flex: 1,
					display: 'flex',
					headerClassName: `${headerClassNames}`,
					headerAlign: 'center',
					align: 'center',
					renderCell: (params: any) => {
						return <div className={`rounded-lg p-2.5 ${params.row.status === 'confirmed' ? 'bg-green-50 text-green-600' : params.row.status === 'rejected' ? 'bg-red-100 text-red-600' : 'bg-blue-100 text-blue-600'}`}>{params.row.status === 'confirmed' ? t('confirmed') : params.row.status === 'rejected' ? t('rejected') : t('confirmation_pend')}</div>;
					},
				},
			],
		},
		{
			title: t('campaigns'),
			api: '/admin/campaigns',
			icon: <AccountBalanceWalletIcon />,
			permission: Campaign.Index,
			columns: [
				{ field: 'title', flex: 1, headerName: t('campaign_name'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				{ field: 'admin_name', flex: 1, headerName: t('title'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				{ field: 'social', flex: 1, headerName: t('media'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				{
					field: 'created_at',
					flex: 1,
					headerName: t('created_time'),
					headerAlign: 'center',
					align: 'center',
					headerClassName: headerClassNames,
					renderCell: (params: any) => {
						return new Date(params.row.created_at).toLocaleDateString('fa-IR');
					},
				},
				{
					field: 'status',
					headerName: t('status'),
					width: 150,
					flex: 1,
					display: 'flex',
					headerClassName: `${headerClassNames}`,
					headerAlign: 'center',
					align: 'center',
					renderCell: (params: any) => {
						return <div className={`rounded-lg p-2.5 ${params.row.status === 'confirmed' ? 'bg-green-50 text-green-600' : params.row.status === 'rejected' ? 'bg-red-100 text-red-600' : 'bg-blue-100 text-blue-600'}`}>{params.row.status === 'confirmed' ? t('confirmed') : params.row.status === 'rejected' ? t('rejected') : t('confirmation_pend')}</div>;
					},
				},
			],
			route: 'admin/view',
		},
	];

	let filterItem = tabItem.find(item => item.title === activeItem);
	return (
		<Box className="w-full">
			<Box className="">
				<ATab items={tabItem} style="" active={activeItem} setActiveItem={setActiveItem} />
			</Box>
			<Box className="mt-7 w-full bg-white">
				<UserTable userId={id} activeItem={activeItem} tabItem={filterItem} />
			</Box>
			<PaymentInfoModal open={open} title={t('see_status')} onClose={handleClose} id={selectedPaymentId || 0} />
		</Box>
	);
};

export default ProfileGiver;
